import React from 'react';

import * as S from './layout';

interface Props {
  originalPrice: string;
  promoPrice?: string;
  inline?: boolean;
  className?: string;
}

const PromoPrice = ({ originalPrice, promoPrice, inline = true, className }: Props) => {
  return (
    <S.Container $inline={inline} className={className}>
      <S.OriginalPrice>{originalPrice}</S.OriginalPrice>
      <S.PromoPrice $inline={inline}>{promoPrice}</S.PromoPrice>
    </S.Container>
  );
};

export default PromoPrice;
